import { GetStaticProps } from 'next';

import PageBookingSearch, {
	PageBookingSearchProps,
} from '../../src/templates/PageBookingSearch/PageBookingSearch';

export default function BookingPage(props: PageBookingSearchProps) {
	return <PageBookingSearch {...props} />;
}

export const getStaticProps: GetStaticProps = async ({ locale = 'en' }) => {
	return {
		props: {},
	};
};
